<template>
  <MessageHTMLComponent
    v-if="this.messageHtmlPath"
    :filePath="this.messageHtmlPath"
    @closeWindow="this.closeMessage"
  />
  <div class="modal modal-journal" v-if="this.dataHistory.length">
    <div class="modal__bg"></div>
    <form class="modal__content">
      <button
        class="modal-journal__close"
        type="button"
        @click="this.closeModal"
      >
        <img src="@/assets/img/icons/close.svg" alt="" width="24" height="24" />
      </button>
      <span class="journal-title"
        >Журнал сообщений по ДТ №{{ dataDT.regnum }}</span
      >
      <div class="journal">
        <div class="journal__main">
          <div class="journal__cover">
            <StatusComponent
              :title="'Статус'"
              :statused="dataDT.statused"
              :solutioncode="dataDT.solutioncode"
            />
            <div class="type-wrapper">
              <div class="type">
                <span class="type__title">Процедура</span>
                <span class="type__main">{{ dataDT.edproc }}</span>
              </div>
              <div class="journal__row">
                <span class="journal__var">Направлена</span>
                <p class="journal__val">{{ dataDT.kodto }}</p>
              </div>
            </div>
            <div class="journal__row">
              <span class="journal__var">ID процедуры</span>
              <p class="journal__val journal__val__idproc">
                {{ dataDT.processid }}
              </p>
            </div>

            <div class="journal__row">
              <span class="journal__var">Альбом форматов/Спецификация</span>
              <p class="journal__val">{{ dataDT.fmtspec }}</p>
            </div>
          </div>
          <!-- <div class="excel-export"> -->
          <!-- <span class="excel__title">В Excel</span> -->
          <download-excel
            class="btn-excel"
            :data="this.dataHistory"
            :header="getJsonHeader()"
            :fields="json_fields"
            :meta="json_meta"
            worksheet="История процедуры"
            name="DT_history.xls"
          >
            <span class="excel__title">В Excel</span>
            <!-- <img
              src="@/assets/img/icons/download.svg"
              class="excel-download"
              alt=""
              width="30"
              height="40"
            /> -->
            <svg
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M15.3687 7.86875L16.25 8.75L10 15L3.75 8.75L4.63125 7.86875L9.375 12.6062V1.25H10.625V12.6062L15.3687 7.86875ZM16.25 17.5V15H17.5V17.5C17.5 17.8315 17.3683 18.1495 17.1339 18.3839C16.8995 18.6183 16.5815 18.75 16.25 18.75H3.75C3.41848 18.75 3.10054 18.6183 2.86612 18.3839C2.6317 18.1495 2.5 17.8315 2.5 17.5V15H3.75V17.5H16.25Z"
                fill="#0D1112"
              />
            </svg>
          </download-excel>

          <!-- </div> -->
        </div>
        <div class="journal__event">
          <div class="journal__event_heads">
            <span class="journal__event_head">Статус</span>
            <span class="journal__event_head">Подробности</span>
            <span class="journal__event_head">Регистрация</span>
            <span class="journal__event_head">Дата ТО</span>
            <span class="journal__event_head">Сообщение</span>
            <!-- <span class="journal__event_head">КДТ</span>
              <span class="journal__event_head">ЭП</span> -->
          </div>
          <div class="journal__event_rows">
            <div
              class="journal__event_row"
              v-for="(item, key) in this.dataHistory"
              :key="key"
            >
              <span class="journal__event_title">{{ item.statustext }}</span>
              <div class="journal__event_center">
                <!-- <p
                  class="journal__event_descr"
                  :class="this.fulldescr ? 'journal__event_descr--opened' : ''"
                  @click="this.fulldescr = !this.fulldescr"
                >
                  >{{ item.substatustext }}
                </p> -->
                <p
                  class="journal__event_descr"
                  :class="
                    this.showDescrRow === key
                      ? 'journal__event_descr--opened'
                      : ''
                  "
                  @click="
                    this.showDescrRow === key
                      ? (this.showDescrRow = -1)
                      : (this.showDescrRow = key)
                  "
                >
                  {{ item.substatustext }}
                </p>
              </div>
              <div class="journal__event_reg">
                <span>Регистрация</span>
                {{ FormatDateToRus(item.registeredat) }}
              </div>
              <div class="journal__event_dt">
                <span>Дата ТО</span>
                {{ FormatDateToRus(item.astoregisteredat) }}
              </div>
              <div class="show-message-btn-cover">
                <button
                  v-if="this.user?.ed_msg_enabled && item.htmlfile"
                  type="button"
                  class="show-message-btn"
                  @click="this.showMessage(item.htmlfile)"
                >
                  Показать...
                </button>
              </div>

              <!-- <a href="#" class="journal__event_dw">
                    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.4425 9.4425L19.5 10.5L12 18L4.5 10.5L5.5575 9.4425L11.25 15.1275V1.5H12.75V15.1275L18.4425 9.4425ZM19.5 21V18H21V21C21 21.3978 20.842 21.7794 20.5607 22.0607C20.2794 22.342 19.8978 22.5 19.5 22.5H4.5C4.10218 22.5 3.72064 22.342 3.43934 22.0607C3.15804 21.7794 3 21.3978 3 21V18H4.5V21H19.5Z" fill="#1D4ED8"/>
                    </svg>
                </a>
                <a href="#" class="journal__event_view">                      
                    <img src="@/assets/img/icons/view.svg" alt="" width="16" height="16">
                </a> -->
            </div>
          </div>
        </div>
      </div>
      <button
        class="modal__full blue-btn"
        type="button"
        @click="this.closeModal"
      >
        Закрыть
      </button>
    </form>
  </div>
  <!-- <div 
    v-if="this.dataHistory.length" 
    class="history-modal__wrapper"
  >
    <ul
      class="history-modal__list"      
    >
      <span class="history-modal__title">Журнал сообщений</span>
      <li
        v-for="(item, key) in this.dataHistory"
        :key="key"
      >
        <div
          class="history-modal__row"
        >
          <span>{{ item.statustext }}</span>
          <span>{{ item.substatustext }}</span>
          <span>{{ item.incomingPerson }}</span>
        </div>
        
      </li>
    </ul>
    <button
      @click="this.closeHistory()"
    >Закрыть</button>
  </div> -->
</template>

<script>
import { mapActions, mapState } from "vuex";
import { StringIsoDateToRus } from "@/common/utils.js";
import StatusComponent from "@/components/Status";
import MessageHTMLComponent from "@/components/MessageHTML";

import JsonExcel from "vue-json-excel3";

export default {
  name: "DTHistory",
  components: {
    downloadExcel: JsonExcel,
    StatusComponent,
    MessageHTMLComponent,
  },
  props: {
    dataDT: {
      type: Object,
      required: true,
    },
  },
  emits: ["closeWindow"],
  data() {
    return {
      showDescrRow: -1,
      messageProcId: "",
      messageDocId: "",
      messageINN: "",
      messageKPP: "",
      messageHtmlPath: "",
      json_fields: {
        Событие: "substatustext",
        Регистрация: "registeredat",
        "Дата ТО": "astoregisteredat",
      },
      json_meta: [
        [
          {
            key: "charset",
            value: "utf-8",
          },
        ],
      ],
    };
  },
  mounted() {
    this.showHistory(this.dataDT.nd);
  },
  computed: {
    ...mapState("DT_HISTORY", ["dataHistory"]),
    ...mapState("Auth", ["user"]),
  },
  methods: {
    ...mapActions("DT_HISTORY", ["showHistory", "closeHistory"]),
    convertDateIsoToRus(_date) {
      return StringIsoDateToRus(_date);
    },
    prevDTEnabled() {
      return true;
    },
    closeModal() {
      this.$emit("closeWindow");
      this.closeHistory();
    },
    FormatDateToRus(_date) {
      if (_date == null) return;

      const formatedDate = `${_date.slice(8, 10)}.${_date.slice(
        5,
        7
      )}.${_date.slice(0, 4)} ${_date.slice(11, 16)}`;
      return formatedDate;
    },
    getJsonHeader() {
      return [
        `Рег.номер ${this.dataDT.regnum}`,
        `Процедура ${this.dataDT.processid}`,
      ];
    },
    showMessage(filePath) {
      this.messageHtmlPath = filePath;
    },
    closeMessage() {
      this.messageHtmlPath = "";
    },
  },
};
</script>
